import { Data } from '@angular/router';
import { UserRoles } from '../enums/user-roles.enum';

export interface IGuardData extends Data {
  permission?: {
    [name: string]: UserRoles[];
  };
}
